<template>
    <div class="out">
        <div class="layout-page-box right" id="title">
            <el-form :inline="true" label-position="right" class="search-form">
                <el-form-item label="院区">
                    <el-select clearable v-model="filters.earId" placeholder="选择院区" multiple>
                        <el-option v-for="(item) in areaOptions" :key="item.areaCode" :label="item.areaName"
                            :value="item.areaCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="楼层">
                    <el-select @focus="focus('lc')" clearable v-model="filters.sknFloor" placeholder="选择楼层" multiple>
                        <el-option v-for="(item) in floorOptions" :key="item.id" :label="item.floorName"
                            :value="item.floorName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="客户姓名">
                    <div class="no">
                        <el-select @blur.capture.native="onBlur('sknName')"
                            @change.capture.native="onInput($event, 'sknName')" :popper-append-to-body="false" clearable
                            v-model="filters.sknName" placeholder="请输入姓名" multiple filterable allow-create></el-select>
                    </div>
                </el-form-item>
                <el-form-item label="手机号">
                    <div class="no">
                        <el-select @blur.capture.native="onBlur('mobile')"
                            @change.capture.native="onInput($event, 'mobile')" :popper-append-to-body="false" clearable
                            v-model="filters.mobile" placeholder="请输入手机号" multiple allow-create filterable></el-select>
                    </div>
                </el-form-item>
                <el-form-item label="划扣项目">
                    <el-select ref='mySelected' @focus="focus(3)" clearable v-model="filters.musProjectNameId"
                        placeholder="选择划扣项目" filterable :filter-method="projectMatch" multiple>
                        <el-option v-for="(item) in projectList" :key="item.id" :label="item.project" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="医生">
                    <el-select @focus="focus(1)" :filter-method="doctorMatch" filterable remote clearable
                        v-model="filters.doctorName" placeholder="选择医生" multiple>
                        <el-option v-for="(item) in newList1" :key="item.identityName" :label="item.identityName"
                            :value="item.identityName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="护士">
                    <el-select @focus="focus(2)" :filter-method="bbMatch" filterable remote clearable
                        v-model="filters.nurseName" placeholder="选择护士" multiple>
                        <el-option v-for="(item) in newList2" :key="item.identityName" :label="item.identityName"
                            :value="item.identityName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="仪器名">
                    <el-input v-model.trim="filters.instrumentName" clearable placeholder="请输入仪器名">
                    </el-input>
                </el-form-item>
                <el-form-item label="诊断">
                    <div class="no">
                        <el-select @blur.capture.native="onBlur('diagnos')"
                            @change.capture.native="onInput($event, 'diagnos')" :popper-append-to-body="false" clearable
                            v-model="filters.diagnosisName" placeholder="请输入诊断" multiple filterable
                            allow-create></el-select>
                    </div>
                </el-form-item>
                <el-form-item label="满足条件">
                    <el-select clearable v-model="filters.isEligibility" placeholder="请选择">
                        <el-option v-for="(item, index) in floors" :key="index" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="日期">
                    <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search" size="small">查询</el-button>
                </el-form-item>
            </el-form>
            <div class=" buttonText">
                <!-- <div class="addData" @click="exp">导出门诊日志</div>
                <div class="addData" @click="exportData">导出使用记录</div> -->
                <el-button type="success" @click="exp" icon="el-icon-check">导出门诊日志</el-button>
                <el-button type="success" @click="exportData" icon="el-icon-check">导出使用记录</el-button>
                <!-- <div class="delete" @click="add">新增数据</div> -->
            </div>
        </div>
        <el-table :row-key="getRowKeys" :cell-style="changeCellStyle" :height="tableHeight"
            @selection-change="handleSelectionChange" :data="tableData" style="width: 100%"
            :row-class-name="tableRowClassName">
            <el-table-column type="selection" :reserve-selection="true"></el-table-column>
            <!-- <el-table-column prop="id" width="100" label="编号" align="center"> </el-table-column> -->
            <el-table-column prop="earName" width="100" label="院区" align="center"> </el-table-column>
            <el-table-column prop="sknFloor" width="100" label="楼层" align="center"> </el-table-column>
            <el-table-column prop="project" label="项目名称" align="center"> </el-table-column>
            <!-- <el-table-column prop="name" label="类别"></el-table-column> -->
            <el-table-column prop="sknDate" width="100" label="日期" align="center"></el-table-column>
            <el-table-column prop="sknName" label="姓名" align="center"></el-table-column>
            <el-table-column prop="sex" width="50" label="性别" align="center"></el-table-column>
            <el-table-column prop="musProjectName" label="划扣项目" align="center"></el-table-column>
            <el-table-column prop="musReplenish" label="划扣补充" align="center"></el-table-column>
            <el-table-column prop="diagnosisName" label="诊断" align="center"></el-table-column>
            <el-table-column prop="handleName" label="处理显示名称" align="center"></el-table-column>
            <el-table-column prop="mobile" label="手机号" align="center" width="150">
                <template slot="header">
                    <span>手机号</span>
                    <el-button style="margin-left:10px;" v-permission="'90'" @click="show" class="filter-item"
                        type="success" size="mini" icon="el-icon-view"></el-button>
                </template>
                <template slot-scope="scope">
                    <span v-if="mobileHiding == true">{{ scope.row.mobile }}</span>
                    <span v-if="mobileHiding == false">
                        <div v-for="(item, index) in scope.row.mobile.split('/')" :key='index'>
                            {{ item.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2") }}</div>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="instrumentName" label="仪器名" align="center"></el-table-column>

            <el-table-column prop="materialName" label="耗材" align="center" width="150">
                <template slot-scope="scope">
                    <div v-for="(item, index) in scope.row.materialName" :key='index'>
                        <div v-if="item.materialIdentification == '0'">{{ item.materialName }}</div>
                        <div v-if="item.materialIdentification == '1'" class="red">{{ item.materialName }}</div>
                    </div>
                </template>
            </el-table-column>

            <!-- <el-table-column prop="materialName" label="耗材" align="center"></el-table-column> -->
            <el-table-column prop="doctorName" label="治疗医生" align="center"></el-table-column>
            <el-table-column prop="nurseName" label="护士" align="center"></el-table-column>
            <!-- <el-table-column align="center" label="操作" width="120">
                <template slot-scope="scope">
                    <el-button :disabled="scope.row.outpatientService==0" size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">选择诊断</el-button>
                </template>
            </el-table-column> -->
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page"
            :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]"
            layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
        </el-pagination>

        <!-- 诊断列表弹框 -->
        <el-dialog center title="请选择诊断" :visible.sync="dialogForm">
            <el-form ref="form" :model="form" label-width="80px">
                <el-form-item>
                    <!-- <el-radio-group class="cardName" size="medium" v-model="form.diagnosisNo">
                        <el-radio style="display:block;" v-for="(item) in loadOptions" :key="item.id" :label="item.id">
                            <span>{{item.diagnosisName}}</span>
                        </el-radio>
                    </el-radio-group> -->
                    <el-checkbox-group class="cardName" size="medium" v-model="form.diagnosisNo">
                        <el-checkbox style="display:block;" v-for="(item) in loadOptions" :key="item.id" :label="item.id">
                            <span>{{ item.diagnosisName }}</span>
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <div class="flex">
                    <el-button @click="dialogForm = false">取消</el-button>
                    <el-button type="primary" @click="onSubmit">保存</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import permission from '../../directives/permission/index'
export default {
    directives: {
        permission
    },
    name: 'outpatients',
    computed: {
        ...mapState(['areaOptions']),
        ...mapGetters(['list1', 'list2', 'list4', 'productOptions', 'createByList', 'areaAndFloorList']),
    },
    data() {
        return {
            tableData: [],
            filters: {
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0
                },
                earId: '',
                earName: '',
                cadCode: '',
                sknFloor: "",
                mobile: '',
                musProjectNameId: '',
                doctorName: '',
                diagnosisName: '',
                startTime: [_g.getMonths()[0], _g.getMonths()[1]],
            },
            projectList: [],
            newList1: [],
            newList2: [],
            newList4: [],
            floorOptions: [],
            dialogForm: false,
            form: {},
            loadOptions: [],
            tableHeight: '',
            outpatientServiceLog: Lockr.get('outpatientServiceLog'),
            instrumentLog: Lockr.get('instrumentLog'),
            mobileHiding: false,
            floors: [
                {
                    id: 1,
                    name: '交付'
                },
                {
                    id: 2,
                    name: '预备'
                },
                {
                    id: 3,
                    name: '留存'
                },
            ]

        }
    },
    watch: {
        '$route'(to, from) {
            if (this.activatedFlag) {
                this.query(this.filters.pagination.page);
            }
        }
    },
    created() {
        this.tableHeight = document.documentElement.clientHeight - 300
    },
    mounted() {
        this.$store.dispatch('getIdList')
        this.query(this.filters.pagination.page)
    },
    methods: {
        getRowKeys(row) {
            return row.id
        },
        show() {
            this.mobileHiding = !this.mobileHiding
        },
        search() {
            this.filters.pagination.page = 1
            this.refresh()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        pageChanged(page) {
            this.filters.pagination.page = page
            this.refresh()
        },
        handleSizeChange(sizes) {
            this.filters.pagination.limit = sizes
            this.refresh()
        },
        refresh() {
            router.push({
                path: this.$route.path,
                query: _.merge({}, this.$route.query, {
                    __query: JSON.stringify(this.pagination)
                }, {
                    random: Math.random()
                })
            })
        },
        // 查询数据列表
        query(page) {
            console.log(this.projectList);
            this.filters.musProjectName = []
            this.filters.earName = []
            this.projectList.forEach(item => {
                // 获取划扣项目选中的名称
                this.filters.musProjectNameId.forEach(ele => {
                    if (ele == item.id) {
                        this.filters.musProjectName.push(item.project)
                    }
                });
            });
            this.areaOptions.forEach(item => {
                // 获取划扣项目选中的名称
                this.filters.earId.forEach(ele => {
                    if (ele == item.id) {
                        this.filters.earName.push(item.project)
                    }
                });
            });
            let querys = {
                page: page,
                size: this.filters.pagination.limit,
                startTime: '',
                endTime: '',
                earId: this.filters.earId.toString(),
                earName: this.filters.earName.toString(),
                cadCode: this.filters.cadCode.toString(),
                sknFloor: this.filters.sknFloor.toString(),
                mobile: this.filters.mobile.toString(),
                musProjectNameId: this.filters.musProjectNameId.toString(),
                musProjectName: this.filters.musProjectName.toString(),
                doctorName: this.filters.doctorName.toString(),
                sknName: this.filters.sknName.toString(),
                instrumentName: this.filters.instrumentName,
                nurseName: this.filters.nurseName.toString(),
                diagnosisName: this.filters.diagnosisName.toString(),
                isEligibility: this.filters.isEligibility
            }
            if (this.filters.startTime) {
                querys.startTime = this.filters.startTime[0]
                querys.endTime = this.filters.startTime[1]
            }
            api.requestQuiet('/skn/findSknOutpatientServiceLogPage', querys, (res) => {
                // console.log(res)
                if (res.result == true) {
                    var data = res.data.list
                    this.tableData = data
                    this.filters.pagination.total = parseInt(res.data.count)
                    this.tableData.forEach(ele => {
                        let reg = new RegExp('，', 'g')//g代表全部
                        ele.mobile = (ele.mobile).replace(reg, '/');
                    });
                }
            }, (err) => { })
        },
        getArr(arr) {
            // 获取每一项下的楼层数组
            let time = arr.map(val => {
                return val.floorNameList
            })
            // 二维数组转一维数组
            let newArr = time.flat();
            // 数组去重
            let obj = {};
            newArr = newArr.reduce((cur, next) => {
                obj[next.floorName] ? "" : obj[next.floorName] = true && cur.push(next);
                return cur;
            }, [])
            return newArr
        },
        focus(val) {
            if (val == 1) {
                this.newList1 = this.list1
            } else if (val == 2) {
                this.newList2 = this.list2
            } else if (val == 4) {
                this.newList4 = this.list4
            } else if (val == 3) {
                this.projectList = this.productOptions
            } else if (val == 5) {
                this.manList = this.createByList
            } else if (val == 'lc') {
                let newArr = this.getArr(this.areaAndFloorList)
                // 给楼层对象赋值
                this.floorOptions = newArr
            }
        },
        doctorMatch(val) {
            this.newList1 = _g.paramMatch(this.list1, this.newList1, val, 'identityName')
        },
        projectMatch(val) {
            this.projectList = _g.paramMatch(this.productOptions, this.projectList, val, 'project')
        },
        // 姓名多选款
        onBlur(val) {
            if (val == 'sknName') {
                if (this.inputName != '' && !this.filters.sknName.includes(this.inputName)) {
                    this.filters.sknName.push(this.inputName)
                }
            } else if (val == 'cadCode') {
                if (this.inputCode != '' && !this.filters.cadCode.includes(this.inputCode)) {
                    this.filters.cadCode.push(this.inputCode)
                }
            } else if (val == 'mobile' && !this.filters.mobile.includes(this.inputMobile)) {
                if (this.inputMobile != '') {
                    this.filters.mobile.push(this.inputMobile)
                }
            } else if (val == 'diagnos' && !this.filters.diagnosisName.includes(this.inputDiagnos)) {
                if (this.inputDiagnos != '') {
                    this.filters.diagnosisName.push(this.inputDiagnos)
                }
            }
        },
        onInput(index, val) {
            if (index.target.value != '') {
                if (val == 'sknName') {
                    this.inputName = index.target.value
                } else if (val == 'cadCode') {
                    this.inputCode = index.target.value
                } else if (val == 'mobile') {
                    this.inputMobile = index.target.value
                } else if (val == 'diagnos') {
                    this.inputDiagnos = index.target.value
                }
            }
        },
        handleEdit(idnex, row) {
            this.form = JSON.parse(JSON.stringify(row))
            if (this.form.diagnosisNo && this.form.diagnosisNo != '') {
                this.form.diagnosisNo = _g.turnNum(this.form.diagnosisNo.split(','))
                this.form.diagnosisName = this.form.diagnosisName.split(',')
            } else if (this.form.diagnosisNo == '' || this.form.diagnosisNo == null) {
                this.form.diagnosisNo = []
                this.form.diagnosisName = []
            }
            api.request('/skn/findProjectMenuByDiagnosis', {
                id: row.musProjectId,
            }, (res) => {
                // console.log(res)
                if (res.result == true) {
                    var data = res.data.sknDiagnosisMenuList
                    this.loadOptions = data
                    if (this.loadOptions.length != 0) {
                        this.dialogForm = true
                    } else if (this.loadOptions.length == 0) {
                        _g.toast("error", '暂无诊断数据');
                    }
                } else {
                    _g.toast("error", res.errMsg);
                }
            }, (err) => { })
        },
        onSubmit() {
            this.form.diagnosisName = []
            this.loadOptions.forEach(item => {
                this.form.diagnosisNo.forEach(ele => {
                    if (item.id == ele) {
                        this.form.diagnosisName.push(item.diagnosisName)
                    }
                });
            });
            let data = {
                id: this.form.id,
                diagnosisName: this.form.diagnosisName.toString(),
                diagnosisNo: this.form.diagnosisNo.toString()
            }
            api.request('/skn/updateSknMusInformation', data, (res) => {
                // console.log(res)
                if (res.result == true) {
                    _g.toast("success", "诊断修改成功");
                    this.dialogForm = false
                    this.query(this.filters.pagination.page)
                } else {
                    _g.toast("error", res.errMsg);
                }
            }, (err) => { })
        },
        changeCellStyle({ column, columnIndex, row, rowIndex }) {
            // console.log(column, columnIndex, row, rowIndex);
            if (this.outpatientServiceLog == '1') {
                // 医生标识
                if (row.doctorIdentification == 1 && column.property == "doctorName") {
                    return 'color: #FF3B4B'
                }
                // 项目标识
                if (row.projectIdentification == 1 && column.property == "musProjectName") {
                    return 'color: #FF3B4B'
                }
                // 医生标识
                if (row.doctorIdentification == 1 && column.property == "doctorName") {
                    return 'color: #FF3B4B'
                }
                // 护士标识
                if (row.nurseIdentification == 1 && column.property == "nurseName") {
                    return 'color: #FF3B4B'
                }
                // 仪器标识
                if (row.instrumentIdentification == 1 && column.property == "instrumentName") {
                    return 'color: #FF3B4B'
                }
            }
        },
        // 表格不同行设置不同的样式
        tableRowClassName({ row, rowIndex }) {
            if (this.outpatientServiceLog == '1') {
                if (row.doctorNameIdentification == 1) {
                    return 'warningGreen';
                }
            }
            return '';
        },
        bbMatch(val) {
            this.newList2 = _g.paramMatch(this.list2, this.newList2, val, 'identityName')
        },
        common(api, name) {
            var data = this.multipleSelection;
            var id = [];
            if (data) {
                data.map(function (item, index) {
                    id.push(item.id);
                });
            }
            this.filters.musProjectName = []
            this.filters.earName = []
            this.projectList.forEach(item => {
                // 获取划扣项目选中的名称
                this.filters.musProjectNameId.forEach(ele => {
                    if (ele == item.id) {
                        this.filters.musProjectName.push(item.project)
                    }
                });
            });
            this.areaOptions.forEach(item => {
                // 获取划扣项目选中的名称
                this.filters.earId.forEach(ele => {
                    if (ele == item.id) {
                        this.filters.earName.push(item.project)
                    }
                });
            });
            let exportUrl = axios.defaults.baseURL;
            var information = {
                total: this.filters.pagination.total,
                category: this.filters.category,
                earId: this.filters.earId.toString(),
                earName: this.filters.earName.toString(),
                cadCode: this.filters.cadCode.toString(),
                sknFloor: this.filters.sknFloor.toString(),
                mobile: this.filters.mobile.toString(),
                musProjectNameId: this.filters.musProjectNameId.toString(),
                musProjectName: this.filters.musProjectName.toString(),
                doctorName: this.filters.doctorName.toString(),
                sknName: this.filters.sknName.toString(),
                createById: Lockr.get('skinEmpId'),
                instrumentName: this.filters.instrumentName,
                nurseName: this.filters.nurseName.toString(),
                mobileHiding: this.mobileHiding,
                diagnosisName: this.filters.diagnosisName.toString(),
                isEligibility: this.filters.isEligibility,
                idList: id.toString()

            }
            if (this.filters.startTime) {
                information.startTime = this.filters.startTime[0]
                information.endTime = this.filters.startTime[1]
            }
            var formData = new FormData();
            formData.append("register", JSON.stringify(information))
            this.$confirm("此操作将导出excel文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.loading = true;
                    axios
                        .post(
                            exportUrl + api, formData, {
                            responseType: "blob",
                        }
                        )
                        .then((res) => {
                            console.log(res)
                            const blob = new Blob([res.data], {
                                type: "application/vnd.ms-excel",
                            });
                            // console.log(blob, '----------0990');
                            const fileName = name;
                            const linkNode = document.createElement("a");
                            linkNode.download = fileName; //a标签的download属性规定下载文件的名称
                            linkNode.style.display = "none";
                            linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
                            document.body.appendChild(linkNode);
                            linkNode.click(); //模拟在按钮上的一次鼠标单击
                            URL.revokeObjectURL(linkNode.href); // 释放URL 对象
                            document.body.removeChild(linkNode);
                            this.loading = false;
                        });
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        exp() {
            this.common("skn/excelSknOutpatientServiceLogList", "门诊日志.xlsx")
        },
        // 导出注射微整科耗材表数据
        exportData() {
            this.common("skn/excelSknInstrumentLogList", "仪器使用记录.xlsx")
        },
    }
}
</script>
<style scoped>
@import "../../assets/css/main.css";

.no>>>.el-select-dropdown {
    display: none;
}

.flex {
    display: flex;
    justify-content: center;
    margin-top: 5px;
}

.el-table>>>.warningGreen {
    background: rgb(143, 214, 143);
}

.out>>>.el-button i {
    margin-right: 0px !important;
}

.red {
    color: #ff3b4b;
}
</style>


